import { render, staticRenderFns } from "./kzEdit.vue?vue&type=template&id=12904d18&"
import script from "./kzEdit.vue?vue&type=script&lang=js&"
export * from "./kzEdit.vue?vue&type=script&lang=js&"
import style0 from "./kzEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "kzEdit.vue"
export default component.exports